import React from 'react';
import { Card, CardContent, CardMedia, Typography, CardActionArea } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function ServiceCard({ service }) {
  return (
    <Card sx={{ height: '100%' }}>
      <CardActionArea component={RouterLink} to={'/services/' + service.slug}>
        <CardMedia component="img" height="160" image={service.heroImage} alt={service.title} />
        <CardContent>
          <Typography variant="h6">{service.title}</Typography>
          <Typography variant="body2" color="text.secondary">{service.summary}</Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
